import { Moment } from 'moment-timezone';
import { Jobsite } from 'apollo/generated/client-operations';
import { WorkerCardErrorInfo } from 'types';
import { JobsitePrinterOption } from 'containers/utils';
import { TempBadge } from 'containers/jobsite/tabs/jobsiteTempBadges/types';
import { BadgeSelection } from 'components/badgeChecklist/types';

export type { WorkerCardAlreadyExistsErrorExtensions } from 'types';

export enum TempBadgingStep {
  CreateAndPrint = 'createAndPrint',
  Printing = 'printing',
  Reprint = 'reprint',
  Register = 'register',
  PrintFailed = 'printFailed',
  Reactivate = 'reactivate',
  ConfirmFinished = 'confirmFinished',
  Assign = 'assign',
  ReassignWorkerBadge = 'reassignWorkerBadge',
  ReactivateWorkerBadge = 'reactivateWorkerBadge',
}

export interface TempBadgeModalProps {
  jobsite: Pick<Jobsite, 'jobsiteId' | 'name'>;
  navigateToTempBadgesOrRefresh: () => void;
}

export type TempBadgeModalOpenValue = {
  modalAction:
    | 'createAndPrint'
    | 'reprint'
    | 'register'
    | 'reactivate'
    | 'assign';
  tempBadge?: TempBadge | null;
};

export type TempBadgeModalState = {
  isOpen: boolean;
  badgingStep: TempBadgingStep | null;
  prevBadgingStep: TempBadgingStep | null;
  tempBadge: TempBadge | null;
  modalAction: TempBadgeModalOpenValue['modalAction'] | null;
  reassignBadgeState: ReassignBadgeState | null;
  workerCardIdToReactivate: string | null;
  expirationDate: Moment | null;
  badgesToDeactivate: BadgeSelection[] | null;
  lastUsedPrinterOption: JobsitePrinterOption | null;
};

export type TempBadgeModalUpdateValue = Partial<
  Pick<
    TempBadgeModalState,
    | 'badgingStep'
    | 'tempBadge'
    | 'reassignBadgeState'
    | 'workerCardIdToReactivate'
    | 'expirationDate'
    | 'badgesToDeactivate'
    | 'lastUsedPrinterOption'
  >
>;

export type ReactivateBadgeState = Pick<
  TempBadgeModalState,
  'workerCardIdToReactivate' | 'expirationDate' | 'badgesToDeactivate'
>;

export type ReassignBadgeState = {
  reassignBadge: () => Promise<void>;
  workerCardInfo: WorkerCardErrorInfo[];
};
